
export default function Hero() {
    return (
        <div className="container-fluid h-[90vh] bg-cover bg-center">
            <div className="absolute flex flex-col h-screen w-full justify-center text-white">
                <div className="text-center mb-32">
                    <h1 className="text-4xl md:text-5xl font-light">CONCIERGE-QUALITY LUXURY</h1>
                    <h1 className="text-5xl md:text-6xl font-extralight">IN EVERY CORNER</h1>
                </div>
                <p className="absolute bottom-24 left-1/2 transform -translate-x-1/2 mt-4 underline">
                    CONNECT WITH YOUR CONCERGE .
                </p>
            </div>
        </div>
    )
}